/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'pencil': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M21.228 4.379L17.621.8A2.09 2.09 0 0016.173.18c-.562 0-1.065.207-1.449.591L1.417 14.078a2.049 2.049 0 00-.592 1.33L.59 19.222c-.03.592.177 1.183.59 1.597a2.06 2.06 0 001.45.591h.117l3.845-.236c.503-.03.977-.236 1.331-.591L21.198 7.307a2.06 2.06 0 00.592-1.449 1.936 1.936 0 00-.562-1.48zm-8.486 2.04l2.868 2.869-6.653 6.623-2.868-2.868 6.653-6.623zM6.237 18.632l-3.046.178.178-3.046.857-.857 2.868 2.868-.857.857zM17.415 7.425l-2.84-2.84 1.597-1.596 2.868 2.868-1.625 1.568z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
